import { render } from "./SquadDutyDetail.vue?vue&type=template&id=0b1c778d"
import script from "./SquadDutyDetail.vue?vue&type=script&lang=js"
export * from "./SquadDutyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__